/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedWordpressArticles_itemSearch = {
    readonly wpArticles: ReadonlyArray<{
        readonly title: string | null;
        readonly imageUrl: {
            readonly thumb: string | null;
            readonly medium: string | null;
            readonly full: string | null;
        } | null;
        readonly subtitle: string | null;
        readonly publishedDate: string | null;
        readonly link: string | null;
        readonly source: string | null;
    } | null> | null;
    readonly " $refType": "SbSharedWordpressArticles_itemSearch";
};
export type SbSharedWordpressArticles_itemSearch$data = SbSharedWordpressArticles_itemSearch;
export type SbSharedWordpressArticles_itemSearch$key = {
    readonly " $data"?: SbSharedWordpressArticles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedWordpressArticles_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedWordpressArticles_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "wpArticles",
      "storageKey": "wpArticles(first:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "WordpressArticleType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "imageUrl",
          "storageKey": null,
          "args": null,
          "concreteType": "WordpressArticleImageType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "thumb",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "medium",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "full",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subtitle",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "publishedDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "source",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '41fbba67c87203423d3272615ca2bfa0';
export default node;
